import { Context, ContextUtil } from './context';
import Constants from '../constants';
import Utils from '../utils';
import EligibilityWrapper from './eligibilityWrapper';
import InlineCommands from './inlineCommands';

export default class Core {
  constructor(custom) {
    if (window.WIOCONFIG.renderVersion === '0.0.0') return;

    if (!window.WIO || !window.WIO.sessionInfo || !window.WIO.sessionInfo.context) {
      Utils.message('No session info', document.location.href);
      return;
    }
    if (!window.WIO || !window.WIO.navTracking || !window.WIO.navTracking.event) {
      Utils.message('No navigation tracking', document.location.href);
      return;
    }
    ContextUtil.massUpdate(window.WIO.sessionInfo.context);
    ContextUtil.update('customerId', custom);

    Utils.initSentry(custom);

    Utils.tryFunction(this.initContext, [null]);
    Utils.tryFunction(this.checkScrollAndClick, [null]);
    setTimeout(() => {
      Utils.tryFunction(this.checkEligibility, [null]);
      Utils.tryFunction(this.initPreviewRenderer, [null]);
    }, 100);
  }

  initContext = () => {
    const ep = Utils.getQueryString('ciblerendpoint') || 'PROD';
    Utils.debug = Utils.getQueryString('ciblerdebug') === 'true' || false;

    ContextUtil.update('ciblerCampaign', Utils.getQueryString('ciblerCampaign'));
    ContextUtil.update('userUUID', Utils.getQueryString('ciblerUserUUID'));
    ContextUtil.update('endpoint', Constants.ENDPOINT.RENDER[ep]);
    ContextUtil.update('cacheEndpoint', ep !== 'PROD' ? Constants.ENDPOINT.RENDER[ep]
      : Constants.ENDPOINT.RENDER.CACHE);
    ContextUtil.update('behaviorUUID', Utils.getQueryString('ciblerBehaviorId'));
    ContextUtil.update('trigger', Utils.getQueryString('ciblerTriggerCampaign'));
    ContextUtil.update('triggerLastCart', Utils.getQueryString('ciblerTriggerLastCart'));
    ContextUtil.update('userGroup', Utils.getQueryString('triggerUserGroup'));
    ContextUtil.update('currentPrize', localStorage.getItem('currentPrize'));
    ContextUtil.update('device', Utils.getDevice());
    ContextUtil.update('timestamp', new Date().getTime());
    ContextUtil.update('scrollCampaign', Utils.getQueryString('ciblerScrollCampaign'));

    const testMode = Utils.getQueryString('ciblerTestMode');
    if (testMode) sessionStorage.setItem('ciblerTestMode', testMode);
    ContextUtil.update('testMode', sessionStorage.getItem('ciblerTestMode'));
    ContextUtil.update('debugMode', sessionStorage.getItem('ciblerDebugMode') || false);
  };

  checkScrollAndClick = () => {
    const anchor = Utils.getQueryString('ciblerScrollAnchor');
    if (!anchor) return;

    const block = document.querySelector(decodeURIComponent(anchor));
    if (!block) return;

    block.scrollIntoView({ behavior: 'smooth' });
    block.click();

    setTimeout(() => this.postScrollTracking(), 1000);
  };

  checkCurrentPrize = () => {
    if (!Context.currentPrize) return;

    const currentPrizeDate = localStorage.getItem('currentPrizeDate');
    if (!currentPrizeDate) {
      localStorage.setItem('currentPrizeDate', (new Date()).getTime());
      return;
    }

    if ((new Date()).getTime() - currentPrizeDate > 259200000) {
      localStorage.removeItem('currentPrize');
      localStorage.removeItem('currentPrizeDate');
      ContextUtil.update('currentPrize', null);
    }
  };

  checkEligibility = () => {
    Utils.tryFunction(this.checkCurrentPrize, [null]);

    EligibilityWrapper.customCall = this.customCall;
    this.customCall();
    // window.WIO.track('testEligibility', true);
    Utils.tryFunction(EligibilityWrapper.checkEligibility, [this.showOperation])
  };

  showOperation = (campaignId) => {
    InlineCommands.customRender = this.customRender;
    document.removeEventListener('mouseout', EligibilityWrapper.handleExit);
    document.removeEventListener('scroll', EligibilityWrapper.handleExitMobile);

    Utils.tryFunction(
      this.inject,
      [EligibilityWrapper.getSrcUrl(Context[campaignId]), {
        campaignId,
        campaigndata: Context[campaignId].campaigndata,
        refuseBlock: this.refuseBlock(campaignId),
        hideBlock: this.hideBlock(campaignId),
        acceptBlock: this.acceptBlock(campaignId),
        customAction: this.customAction(campaignId),
        crossSellCustomAction: this.crossSellCustomAction,
      }, this.showCallBack(campaignId)],
    );
  };

  callEligibility = () => Utils.tryFunction(EligibilityWrapper.checkEligibility, [this.showOperation]);

  showCallBack = campaignId => (showed) => {
    if (!showed) return;

    Utils.tryFunction(this.customShowOperation, [campaignId]);

    const gameIFrame = document.getElementById('WioGame');
    const ciblerData = atob(localStorage.getItem('cib_postback'));
    if (ciblerData && ciblerData !== '' && gameIFrame) {
      gameIFrame.contentWindow.postMessage(ciblerData, '*');
    }

    if (Context.oauthOpen) {
      window.WIO.track('clickOnButton', campaignId);
      this.loadGame();
    } else {
      window.WIO.track('showOperation', campaignId, Context[campaignId].sessionId);
      if (Context[campaignId].successRateId) window.WIO.track('successView', Context[campaignId].successRateId);
    }
  };

  initPreviewRenderer = () => {
    window.addEventListener('message', (e) => {
      InlineCommands.customRender = this.customRender;
      if (!e.data || e.data.owner !== 'cibler' || e.data.name !== 'updateStyle') return;

      const device = Utils.getDevice();
      const { campaignId, desktop, mobile } = e.data;
      const overRide = device === 'desktop' ? desktop : mobile;

      this.hideBlock(campaignId)();
      Utils.tryFunction(
        this.inject,
        [EligibilityWrapper.getSrcUrl(Context[campaignId]), {
          campaignId,
          campaigndata: { ...Context[campaignId].campaigndata, ...overRide },
          refuseBlock: this.refuseBlock(campaignId),
          hideBlock: this.hideBlock(campaignId),
          acceptBlock: this.acceptBlock(campaignId),
          customAction: this.customAction(campaignId),
        }, () => undefined],
      );
    });
  };

  loadGame = () => false;
  customShowOperation = () => false;
  inject = InlineCommands.inject;
  refuseBlock = InlineCommands.refuseBlock;
  hideBlock = InlineCommands.hideBlock;
  acceptBlock = InlineCommands.acceptBlock;
  customAction = () => false;
  customRender = () => false;
  customCall = () => false;
  crossSellCustomAction = () => false;
  getContext = () => Context;
  postScrollTracking = () => false;
  openFunctions = {};
  secureOpenFunctions = {};
}

window.WIOCONFIG.callRender = (customerId) => {
  if (window.WIORENDER) return;

  window.WIORENDER = new Core(customerId || window.WIO.customerId);
};
